import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "children", "className", "inheritFont", "variant", "isExternal"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { ArrowUpRightSquareAlt } from '@box/blueprint-web-assets/icons/Line';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './link.module.js';
var LinkDefaultAsElement = 'a';
var Link = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? LinkDefaultAsElement : _props$as,
      children = props.children,
      className = props.className,
      inheritFont = props.inheritFont,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inline' : _props$variant,
      _props$isExternal = props.isExternal,
      isExternal = _props$isExternal === void 0 ? false : _props$isExternal,
      rest = _objectWithoutProperties(props, _excluded);

  return jsxs(Component, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx([className, styles.link, _defineProperty({}, styles.inheritFont, inheritFont), styles[variant], _defineProperty({}, styles.hasIcon, isExternal)]),
    children: [children, isExternal && jsx(ArrowUpRightSquareAlt, {
      "aria-hidden": true,
      className: styles.icon
    })]
  }));
});
export { Link };